<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <template v-slot:header>
                <h5>Detail Surat BPKB</h5>
            </template>
            <div class="detail-data-wrapper mb-3">
                <h6 class="form-title">DATA SURAT</h6>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Jenis Surat</b-col>
                    <b-col>
                        {{dataSingleSuratBpkb.jenis}}
                    </b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Tanggal Request</b-col>
                    <b-col>
                        {{ $helper.changeDateFormat(dataSingleSuratBpkb.tanggalRequest )}} {{ $helper.changeDateFormatGetHour(dataSingleSuratBpkb.tanggalRequest )}}
                    </b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Tanggal Surat</b-col>
                    <b-col>
                        {{ $helper.changeDateFormat(dataSingleSuratBpkb.tanggalSurat )}} {{ $helper.changeDateFormatGetHour(dataSingleSuratBpkb.tanggalSurat )}}
                    </b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Tujuan Surat</b-col>
                    <b-col>
                        {{ dataSingleSuratBpkb.tipeAlamat }}
                    </b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Jarak Hari Skema 1 (Jasa Dibelakang)</b-col>
                    <b-col v-if="$helper.isNotNullAndNotEmpty(dataSingleSuratBpkb.jarakHari)">
                        {{ dataSingleSuratBpkb.jarakHari }} hari dari jatuh tempo
                    </b-col>
                    <b-col v-else>-</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Jarak Hari Skema 2 (Jasa Didepan)</b-col>
                    <b-col v-if="$helper.isNotNullAndNotEmpty(dataSingleSuratBpkb.jarakHariSkema2)">
                        {{ dataSingleSuratBpkb.jarakHariSkema2 }} hari dari jatuh tempo
                    </b-col>
                    <b-col v-else>-</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Jumlah Cabang</b-col>
                    <b-col>{{ $helper.addThousandSeparator(dataSingleSuratBpkb.jumlahCabang) }}</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Total Surat</b-col>
                    <b-col>{{ $helper.addThousandSeparator(dataSingleSuratBpkb.totalSurat) }}</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Status</b-col>
                    <b-col>{{ dataSingleSuratBpkb.status }}</b-col>
                </b-row>
            </div>
            <div class="detail-data-wrapper mb-4">
                <b-button variant="danger" v-if="dataSingleSuratBpkb.status == 'PENDING'" @click="openConfirm">Batalkan Request</b-button>
                <div v-else-if="dataSingleSuratBpkb.status == 'SIAP CETAK'">
                    <b-button variant="pgiBtn" class="mb-4 mr-2 download-btn">
                        <a v-bind:href="$baseFilePath + dataSingleSuratBpkb.filepath" target="_blank">
                            <i class="fa fa-download mr-2"></i>
                            Download Surat (.zip)
                        </a>
                    </b-button>
                    <b-button v-if="dataSingleSuratBpkb.excelPath != null" variant="pgiBtn" class="mb-4 mr-2 download-btn" @click="confirmLaporanDownloadExcel">
                        <i class="fa fa-download mr-2"></i>
                        Download List Surat (Excel)
                    </b-button>
                </div>
            </div>
            <div class="detail-data-wrapper mb-4">
                <h6 class="form-title">DETAIL SURAT CABANG</h6>
                <b-table bordered hover show-empty sticky-header :fields="fields" :items="dataSingleSuratBpkb.detail" >
                    <template v-slot:empty>
                        Tidak ada surat.
                    </template>
                </b-table>
            </div>
        </b-card>
        <ModalConfirm id="modal-confirm-cancel" title="Confirm Batalkan Request" :isSubmitting="isSubmitting" desc="Apakah anda yakin untuk membatalkan request ini?" @submit="onCancelRequest()" />
        <ModalConfirm id="modal-confirm-cetak" title="Confirm Cetak List Surat (Excel)" :isSubmitting="isSubmitting" desc="Apakah anda yakin untuk mencetak list surat excel ini?" @submit="openListExcelDownload" />
        <b-modal id="modal-download-excel" centered title="Download List Surat Excel" hide-footer no-close-on-backdrop>
            <div class="show-btn-download">
                <p class="">
                    Silakan download dengan klik tombol dibawah ini :
                </p>
                <b-button variant="pgiBtn" class="mb-0 download-btn">
                    <a v-bind:href="$baseFilePath + dataSingleSuratBpkb.excelPath" download>
                        <i class="fa fa-download mr-2"></i>
                        Download Excel
                    </a>
                </b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
export default {
    name: 'detail-surat-bpkb',
    data(){
        return{
            id: null,
            initStatus: 0,
            isSubmitting: false,
            isBusy: true,
            dataSingleSuratBpkb:{
            },
            fields: [
                { key: "cabang", label: "Cabang", sortable:true },
                { key: "jumlahSurat", label: "Jumlah Surat", sortable:true },
            ],
        }
    }, 

    methods:{

        //----------------- Fungsi Inisialisasi -----------------

        init(){
            this.initStatus = 0
            this.id = this.$route.params.id

            let getSingleDataSuratBpkb = this.$axios.get(`surat-bpkb/${this.id}`).then(response => {
                this.dataSingleSuratBpkb = response.data
     
                let msg = this.$helper.getFlash()
                this.$helper.toastSucc(this, msg)
            })

            Promise.all([getSingleDataSuratBpkb]).then(() => {
                this.initStatus = 1
                this.toggleBusy()
            })
            .catch(error => {
                console.log(error)
                this.initStatus = -1
            })

        },

        //----------------- Fungsi Pindah Halaman dan Fungsi Lain -----------------

        toggleBusy() {
            if (this.isBusy == true) this.isBusy = false
            else this.isBusy = true
        },

        onCancelRequest(){
            let payload = new FormData()

             //----------------- Append Data Cancel -----------------

            payload.append("id", this.id)


            //----------------- Submit Semua Data -----------------

            this.isSubmitting = true

            this.$axios.post("surat-bpkb/cancel/", payload).then(() => {
                this.$helper.setFlash(`Surat BPKB berhasil dibatalkan!`)
                let path = this.$route.path.split("/")
                path.pop()
                path = path.join("/")
                this.$router.push({ path })
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isSubmitting = false
            })
        },

        openConfirm(){
            this.$bvModal.show("modal-confirm-cancel")
        },

        confirmLaporanDownloadExcel(){
            this.$bvModal.show("modal-confirm-cetak")
        },

        openListExcelDownload(){
            this.$bvModal.show('modal-download-excel')
            this.$bvModal.hide('modal-confirm-cetak')
        },

    },

    created(){
        this.init()
    }
}
</script>
